import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
/** The student's classes (published schedules of their shift), with attendance + materials. */
export function useMyClasses() {
    return useQuery({
        queryKey: ['student-classes'],
        queryFn: () => apiClient('/attendance/student/me/classes'),
        staleTime: 1000 * 60 * 2,
    });
}
//# sourceMappingURL=useMyClasses.js.map